// extracted by mini-css-extract-plugin
export default {"game_rank":"GameRank_game_rank__xU0OA","page":"GameRank_page__FShyQ","page_container":"GameRank_page_container__z9icY","loading":"GameRank_loading__MPrxN"};